/* Mini layout analysis: face positions only. No recognition, identities or external photo uploads. */
(() => {
  let ready;
  const load = (config) => ready ||= (async () => {
    await new Promise((resolve, reject) => {
      const script = document.createElement('script'); script.src=config.faceLibUrl;
      const timer=setTimeout(()=>reject(new Error('photo_analysis_timeout')),8000);
      script.onload=()=>{clearTimeout(timer);resolve();}; script.onerror=()=>{clearTimeout(timer);reject(new Error('photo_analysis_unavailable'));}; document.head.appendChild(script);
    });
    const api=window.faceapi;
    await api.tf.setBackend('cpu');
    const manifestResponse=await fetch(config.faceManifestUrl,{signal:AbortSignal.timeout(8000)});
    const weightsResponse=await fetch(config.faceWeightsUrl,{signal:AbortSignal.timeout(8000)});
    if(!manifestResponse.ok||!weightsResponse.ok)throw new Error('photo_analysis_unavailable');
    const manifest=await manifestResponse.json(),weights=await weightsResponse.arrayBuffer();
    await api.nets.tinyFaceDetector.loadFromWeightMap(api.tf.io.decodeWeights(weights,manifest.flatMap(group=>group.weights)));
    return api;
  })();
  window.OurStoryPhotoAnalysis={async analyse(canvas,config){
    try {
      const api=await load(config),small=document.createElement('canvas');
      const scale=Math.min(1,640/Math.max(canvas.width,canvas.height));
      small.width=Math.round(canvas.width*scale);small.height=Math.round(canvas.height*scale);
      small.getContext('2d').drawImage(canvas,0,0,small.width,small.height);
      const faces=await api.detectAllFaces(small,new api.TinyFaceDetectorOptions({inputSize:608,scoreThreshold:.35}));
      return {method:'tiny-face-detector-0.22.2',faces:faces.map(face=>({x:face.box.x/small.width,y:face.box.y/small.height,width:face.box.width/small.width,height:face.box.height/small.height,score:face.score}))};
    } catch (_) {return null;}
  }};
})();
